/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { AddressFragmentDoc } from '../../../../graphql/fragments/CustomerData.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type CustomerAddressesQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerAddressesQuery = {
  readonly currentCustomer: {
    readonly __typename: 'Customer';
    readonly id: string;
    readonly addresses: ReadonlyArray<{
      readonly __typename: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly name: string | null;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly country: string;
      readonly deliveryPreference: Types.DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly notes: string | null;
    }>;
  } | null;
};

export const CustomerAddressesDocument = gql`
  query CustomerAddresses {
    currentCustomer {
      id
      __typename
      addresses {
        ...address
      }
    }
  }
  ${AddressFragmentDoc}
`;

export function useCustomerAddressesQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerAddressesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>({
    query: CustomerAddressesDocument,
    ...options,
  });
}
